<template>
<footer class="footer" style="margin-top:2rem">
  <nav class="level">
	<div class="level-left">
		<div class="level-item">© College of Education at the University of Texas at Austin 2020</div>
		</div>
		<div class="level-right">
			<div class="level-item"><a href="mailto:oi2@utexas.edu" style="color:#A04400;">Feedback</a> | <a href="http://www.utexas.edu/site-policies" style="color:#A04400;">Site Policies</a> | <a href="https://cio.utexas.edu/policies/web-privacy" style="color:#A04400;">Web Privacy Policy</a> | <a href="https://cio.utexas.edu/policies/web-accessibility" style="color:#A04400;">Web Accessibility Policy</a> | <a href="https://get.adobe.com/reader/" style="color:#A04400;" target="_blank">Adobe Reader</a></div>
		</div>
	</nav>
	</footer>
</template>

<script>
export default {
}
</script>

<style lang='scss'>
.footer{
  margin-top:40px;
}
</style>